import { FC, useRef, useEffect } from "react";
import styles from "./LineStylePopup.module.css";

const COLORS = [
  "#ef4444", "#f97316", "#eab308", "#22c55e",
  "#14b8a6", "#3b82f6", "#8b5cf6", "#ec4899",
  "#ffffff", "#94a3b8", "#475569", "#1e293b",
];

interface Props {
  color: string;
  width: number;
  onColorChange: (color: string) => void;
  onWidthChange: (width: number) => void;
  onClose: () => void;
}

export const LineStylePopup: FC<Props> = ({ color, width, onColorChange, onWidthChange, onClose }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        document.addEventListener("click", (ce) => ce.stopPropagation(), { capture: true, once: true });
        onClose();
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [onClose]);

  return (
    <div ref={ref} className={styles.popup}>
      <span className={styles.sectionLabel}>Line color</span>
      <div className={styles.grid}>
        {COLORS.map((c) => (
          <button
            key={c}
            className={`${styles.swatch} ${c === color ? styles.selected : ""}`}
            style={{ background: c }}
            onClick={() => onColorChange(c)}
          />
        ))}
      </div>
      <span className={styles.sectionLabel}>Line width</span>
      <div className={styles.widthRow}>
        {[1, 2, 3, 4, 5].map((w) => (
          <button
            key={w}
            className={`${styles.widthBtn} ${w === width ? styles.widthBtnActive : ""}`}
            onClick={() => onWidthChange(w)}
          >
            {w}px
          </button>
        ))}
      </div>
    </div>
  );
};
